import { ALLOWED_42CFRP2_EMAIL_DOMAINS } from "../constants/predicates";
import type { PredicateContext } from "../types";

// Federal regulation 42 CFR Part 2
export function isAllowed42CFRP2Email({ email }: PredicateContext) {
  if (!email) return false;

  const domain = email.split("@")[1]?.toLowerCase();

  return ALLOWED_42CFRP2_EMAIL_DOMAINS.includes(domain);
}

// Users allowed to approve/reject acuity updates
export function isAcuityScoreApprover({ approvers, username }: PredicateContext) {
  if (!username || !approvers) return false;

  return approvers.includes(username);
}
